(function() {
angular.module('app.ui.form.ctrls')
.controller('jobPracticesModalCtrl', [
    '$scope',
    '$log',
    '$modalInstance',
    'practicesService',
    'data',
    function($scope, $log, $modalInstance, practicesService, data) {
      $scope.data = [];
      $scope.data = data;
      $scope.CheckBox = '';
      $scope.updatedData = {
        data: [],
        linearPractices: []
      };
      $log.info("data",data);
      $scope.updatedData.data = $scope.data;
      $scope.displaySubPracticeAreas = function(law_area) {
        return law_area.showSubPracticeAreas = true;
      };
      $scope.hideSubPracticeAreas = function(law_area) {
        return law_area.showSubPracticeAreas = false;
      };
      $scope.updateData = function(event, cur_box) {
        var value;
        value = event.target.checked;
        $scope.updatedData.forEach(function(chkbox, index, array) {
          if (chkbox.practice_ID === cur_box.practice_ID) {
            chkbox.isSelected = value;
          }
        });
      };

      $scope.selectPractices = function(event, current, level) {
        var pCounter, sCounter, value;
        pCounter = 0;
        sCounter = 0;
        value = event.target.checked;
        if (level === 2) {
          // $log.info('level 2');
          $log.info(current);
          $scope.updatedData.data.forEach(function(law_area, index, array) {
            if (law_area.practice_ID === current.practice_ID) {
              law_area.isSelected = value;
              law_area.practices.forEach(function(practice, index, array) {
                practice.isSelected = value;
                practice.sub_areas.forEach(function(sub, index, array) {
                  if (sub.isSelected !== value) {
                    sub.isSelected = value;
                  }
                });
              });

              practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
            }
          });
          return;
        } else if (level === 1) {
          $scope.updatedData.data.forEach(function(law_area, index, array) {
            return law_area.practices.forEach(function(practice, index, array) {
              if (practice.practice_ID === current.practice_ID) {
                $log.info(current.practice_ID);
                practice.isSelected = value;
                law_area.practices.forEach(function(p, i, a) {
                  if (p.isSelected) {
                    pCounter++;
                  }
                });
                $log.info('pCounter : ' + pCounter);
                if (value) {
                  if (pCounter > 0) {
                    law_area.isSelected = value;
                  }
                } else {
                  if (pCounter <= 0) {
                    law_area.isSelected = value;
                  }
                }
                practice.sub_areas.forEach(function(sub, index, array) {
                  if (sub.isSelected !== value) {
                    sub.isSelected = value;
                  }
                });

                practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
              }
            });
          });
          return;
        } else if (level === 0) {
          $scope.updatedData.data.forEach(function(law_area, index, array) {
            law_area.practices.forEach(function(practice, index, array) {
              if (practice.sub_areas.length > 0) {
                practice.sub_areas.forEach(function(sub, index, array) {
                  if (sub.practice_ID === current.practice_ID) {
                    sub.isSelected = value;
                    practice.sub_areas.forEach(function(s, i, a) {
                      if (s.isSelected) {
                        sCounter++;
                      }
                    });
                    $log.info('pCounter : ' + pCounter);
                    if (value) {
                      if (sCounter > 0) {
                        law_area.isSelected = value;
                        practice.isSelected = value;
                      }
                    } else {
                      if (sCounter <= 0) {
                        practice.isSelected = value;
                        law_area.practices.forEach(function(p, i, a) {
                          if (p.isSelected) {
                            pCounter++;
                          }
                        });
                        $log.info('pCounter : ' + pCounter);
                        if (value) {
                          if (pCounter > 0) {
                            law_area.isSelected = value;
                          }
                        } else {
                          if (pCounter <= 0) {
                            law_area.isSelected = value;
                          }
                        }
                      }
                    }
                    practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
                  }
                });
              }
            });
          });
        }
      };
      $scope.save = function() {
        $scope.updatedData.linearPractices = [];
        $scope.updatedData.data.forEach(function(law_area, index, array) {
          $scope.updatedData.linearPractices.push(law_area);
          law_area.practices.forEach(function(practice, index, array) {
            $scope.updatedData.linearPractices.push(practice);
            practice.sub_areas.forEach(function(sub, index, array) {
              return $scope.updatedData.linearPractices.push(sub);
            });
          });
        });
        $modalInstance.close($scope.updatedData);
      };
      $scope.cancel = function() {
        $modalInstance.dismiss("cancel");
      };
    }
  ]);
}());


// WEBPACK FOOTER //
// ./scripts/shared/jobPracticesModalCtrl.js